const currentMenuItemDefaultState = {
    item: {},
    itemtype: '',
    loading: true,
    error: false,
};

export default (state = currentMenuItemDefaultState, action) => {

    switch(action.type) {

        case 'LOAD_MENU_ITEM':
            return {
                ...state,
                item: action.item,
                itemtype: action.itemtype,
                loading: false
            }

        case 'MENU_ITEM_ERROR':
            return {
                ...state,
                loading: false,
                error
            }

        default:
            return state;
    }
};